import { AssessorAssignmentsValue } from './assessor-assignments.value';

export class AssessorAssignmentsValueDto {
    organisationIds: string[];
    schoolIds: string[];
    courseIds: string[];
    packageIds: string[];

    constructor(data: AssessorAssignmentsValue) {
        this.organisationIds = data.organisationIds;
        this.schoolIds = data.schoolIds;
        this.courseIds = data.courseIds;
        this.packageIds = data.packageIds;
    }
}
